import { useMutation, useQuery } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';
import { useCurrentUser } from '@bonusly/who-am-i';

import { ReviewSolicitation } from '../lib';
import { ReviewSolicitationApiData } from '../types/review-solicitation';

enum QueryKey {
	ReviewSolicitations = 'review-solicitations',
}

export const useGetReviewSolicitation = () => {
	const http = useHttpClient('v2');
	const user = useCurrentUser();

	return useQuery({
		queryKey: [QueryKey.ReviewSolicitations, user.id],
		queryFn: async () => http.get<ReviewSolicitationApiData>('/review_solicitations'),
		enabled: !!user,
		select: (data) => {
			return ReviewSolicitation.fromApiData(data.data);
		},
	});
};

export const useRecordReviewSolicitation = () => {
	const http = useHttpClient('v2');

	return useMutation({
		mutationFn: () => http.post<ReviewSolicitationApiData>('/review_solicitations'),
	});
};

export const useRemindLaterReviewSolicitation = () => {
	const http = useHttpClient('v2');

	return useMutation({
		mutationFn: () =>
			http.post<ReviewSolicitationApiData>('/review_solicitations', {
				remind_later: true,
			}),
	});
};
